import { useT } from "../i18n";

const Row = ({ items }) => (
  <div className="flex shrink-0 items-center">
    {items.map((item) => (
      <span key={item} className="flex items-center">
        <span className="px-8 font-mono text-xs tracking-[0.35em] text-slate-500">{item}</span>
        <span className="h-1.5 w-1.5 rotate-45 bg-gold/50" />
      </span>
    ))}
  </div>
);

const Marquee = () => {
  const t = useT();
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-gold/10 bg-[#0B132B] py-5">
      <div className="animate-marquee flex w-max">
        <Row items={t.marquee} />
        <Row items={t.marquee} />
      </div>
    </div>
  );
};

export default Marquee;
